import { render, staticRenderFns } from "./secondConfirm.vue?vue&type=template&id=5ecc85a8&scoped=true"
import script from "./secondConfirm.vue?vue&type=script&lang=js"
export * from "./secondConfirm.vue?vue&type=script&lang=js"
import style0 from "./secondConfirm.vue?vue&type=style&index=0&id=5ecc85a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc85a8",
  null
  
)

export default component.exports